document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const openShowModalButton = document.getElementById('openShowModal');
  const closeButton = document.getElementById('close');
  const dialog = document.getElementById('nutrition-dialog');

  if (!dialog || !closeButton || !openShowModalButton) return;

  let previouslyFocusedElement = null;

  const handleClickOutside = (event) => {
    const dialogRect = dialog.getBoundingClientRect();
    const isClickInsideDialog =
      event.clientX >= dialogRect.left &&
      event.clientX <= dialogRect.right &&
      event.clientY >= dialogRect.top &&
      event.clientY <= dialogRect.bottom;

    if (!isClickInsideDialog) {
      closeDialog();
    }
  };

  function openDialog() {
    previouslyFocusedElement = document.activeElement;
    dialog.showModal();
    body.style.overflow = 'hidden';

    const firstFocusable = dialog.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    (firstFocusable || dialog).focus();

    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);
  }

  function closeDialog() {
    dialog.close();
    body.style.overflow = 'unset';
    document.removeEventListener('click', handleClickOutside);

    if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
      previouslyFocusedElement.focus();
    }
  }

  openShowModalButton.addEventListener('click', (e) => {
    e.preventDefault();
    openDialog();
  });

  closeButton.addEventListener('click', () => {
    closeDialog();
  });

  dialog.addEventListener('cancel', () => {
    closeDialog();
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      if (!dialog.hasAttribute('open')) {
        closeDialog();
      }
    });
  });

  observer.observe(dialog, {
    attributes: true,
    attributeFilter: ['open'],
  });
});
